function stripRid(value) {
  if (!value) return null;
  return String(value).replace(/^#/, '');
}

function getOccurredAtRid(eventRecord) {
  return eventRecord
    && eventRecord.out_OccurredAt
    && eventRecord.out_OccurredAt[0]
    && eventRecord.out_OccurredAt[0].in
    && eventRecord.out_OccurredAt[0].in['@rid']
    ? stripRid(eventRecord.out_OccurredAt[0].in['@rid'])
    : null;
}

function buildEventReportDownloadOptions(eventRecord, contextLocation) {
  var eventRid = stripRid(eventRecord && eventRecord['@rid']);
  var reportRid = stripRid(eventRecord && eventRecord.reportRid);
  var reportType = eventRecord && eventRecord.reportType ? String(eventRecord.reportType) : null;
  var baseOptions = {
    modalTitle: 'Download event report',
    eventRid: eventRid,
    eventRecord: eventRecord,
    contextLocation: contextLocation
  };

  if (reportRid && reportType) {
    return Object.assign({}, baseOptions, {
      sourceKind: 'reportRecord',
      reportRid: reportRid,
      reportType: reportType
    });
  }

  return Object.assign({}, baseOptions, {
    reportType: 'AutomaticTransferSwitch:event',
    targetKind: 'location',
    targetRid: getOccurredAtRid(eventRecord),
    targetClassName: 'AutomaticTransferSwitch'
  });
}

module.exports = buildEventReportDownloadOptions;
module.exports.__testables = {
  stripRid: stripRid,
  getOccurredAtRid: getOccurredAtRid,
  buildEventReportDownloadOptions: buildEventReportDownloadOptions
};
